import React from "react";
import { overviewsSlice } from "@common/redux/slices/entities.slice";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice"
import { Layout } from "@kursk/components/Layout/Layout";
import { Socials } from "../Home/Socials/Socials";
import { ArtefactsGrid } from "./ArtefactsGrid/ArtefactsGrid";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import styles from './Artefacts.module.scss';
import { CatalogueTitle } from "@kursk/components/ui/CatalogueTitle/CatalogueTitle";

export const Artefacts = () => {
  const { total } = useSelectSlice(overviewsSlice);

  return (
    <Layout showSubscribePopup={false}>
      <SeoMetaTitles page="artefacts"/>
      <section className={styles.section_content}>
        <div className={styles.header}>
          <CatalogueTitle
            title={'Дополненная реальность'}
            dashTitle={'Найдено гидов'}
            total={total}
          />
        </div>
        <div className={styles.items}>
          <ArtefactsGrid/>
        </div>
        <div className={styles.subscribeSection}>
          <SubscribeFooterForm/>
        </div>
        <div className={styles.section}>
          <Socials/>
        </div>
      </section>
    </Layout>
  );
}
